
import CleanerPicker from './cleaner-picker.vue';

export default {
  name: "SideMenu",
  props: {},
  components: {
    CleanerPicker
  },
  mounted() { },
  created() {
    let t = this;

    t.$eventBus.$on('openCleanerPicker', () => {
      t.showCleanerPicker = true;
    });

    t.$eventBus.$on('closeCleanerPicker', () => {
      t.showCleanerPicker = false;
    });

    let reg = /(monitor|v2|schedule|item|rooms|pl_.+|guests|all_stocks|sup_tasks|cc|analysis|att_table|room_stocks|print_form|room_stats)/i;

    let expandConfig = {
      'schedule': /att_table|v2|schedule|sup_tasks/,
      'members': /pl_.+|guests/,
      'item': /all_stocks|room_stocks/,
    };

    function isOwnerRoute(route) {
      var path = (route && route.path) || '';
      return path === '/owner' || path.indexOf('/owner/') === 0;
    }

    function refreshPlaform(route) {
      route = route || t.$router.currentRoute;
      var onOwner = isOwnerRoute(route);
      if (onOwner) {
        if (!document.body.classList.contains('pc')) {
          document.body.classList.add('pc');
        }
        if (!document.body.classList.contains('owner-portal')) {
          document.body.classList.add('owner-portal');
        }
      } else {
        if (document.body.classList.contains('owner-portal')) {
          document.body.classList.remove('owner-portal');
        }
        if (t.showNav) {
          if (!document.body.classList.contains('pc')) {
            document.body.classList.add('pc');
          }
        } else {
          if (document.body.classList.contains('pc')) {
            document.body.classList.remove('pc');
          }
        }
      }
    }

    function applyRoute(route) {
      if (isOwnerRoute(route)) {
        t.showNav = false;
        t.page = '';
      } else {
        let r = reg.exec(route.path);
        if (r && r.length > 0) {
          t.page = r[1];
          t.showNav = true;
          for (const key in expandConfig) {
            if (expandConfig[key].test(t.page)) {
              t.expanded = key;
              break;
            }
          }
          var path = route.path || '';
          if (path.indexOf('/pl_landlord_settlement') === 0 || path.indexOf('/pl_landlord_overview') === 0 || path.indexOf('/pl_landlord_stay_tax') === 0) {
            t.expanded = 'room';
          }
        } else {
          t.showNav = false;
        }
      }
      refreshPlaform(route);
    }

    t.$router.beforeEach((to, from, next) => {
      applyRoute(to);
      next();
    });

    applyRoute(t.$router.currentRoute);
  },
  computed: {
    isPlLandlord: function () {
      var path = (this.$route && this.$route.path) || '';
      if (path.indexOf('/pl_landlord_settlement') === 0 || path.indexOf('/pl_landlord_overview') === 0 || path.indexOf('/pl_landlord_stay_tax') === 0) {
        return false;
      }
      return path === '/pl_landlord' || path.indexOf('/pl_landlord_') === 0;
    },
    isSettlementNav: function () {
      var path = (this.$route && this.$route.path) || '';
      return path.indexOf('/pl_landlord_settlement') === 0;
    },
    isOverviewNav: function () {
      var path = (this.$route && this.$route.path) || '';
      return path.indexOf('/pl_landlord_overview') === 0;
    },
    isStayTaxNav: function () {
      var path = (this.$route && this.$route.path) || '';
      return path.indexOf('/pl_landlord_stay_tax') === 0;
    }
  },
  methods: {
    goPage(page) {
      if (page == this.page) return;

      this.page = page;

      var pending = this.$router.push(page);
      if (pending && pending.catch) pending.catch(function () {});
    },
    sameRoute(path, query) {
      var route = this.$route || {};
      if ((route.path || '') !== path) return false;
      query = query || {};
      var current = route.query || {};
      var key;
      for (key in query) {
        if (String(current[key] || '') !== String(query[key] || '')) return false;
      }
      for (key in current) {
        if (query[key] == null && current[key] != null && current[key] !== '') return false;
      }
      return true;
    },
    pushRoute(location) {
      var path = typeof location === 'string' ? location : location.path;
      var query = typeof location === 'string' ? null : location.query;
      if (this.sameRoute(path, query)) return;
      var pending = this.$router.push(location);
      if (pending && pending.catch) pending.catch(function () {});
    },
    goLandlordAdmin() {
      this.pushRoute('/pl_landlord');
    },
    goSettlementStatus() {
      var q = (this.$route && this.$route.query) || {};
      if (q.landlord_id) {
        this.pushRoute({ path: '/pl_landlord_settlement', query: { landlord_id: q.landlord_id } });
        return;
      }
      this.pushRoute('/pl_landlord');
    },
    goOverview() {
      this.pushRoute('/pl_landlord_overview');
    },
    goStayTax() {
      this.pushRoute('/pl_landlord_stay_tax');
    },
    expandToggle(name) {
      if (this.expanded != name) this.expanded = name;
      else this.expanded = '';
    },
  },
  data() {
    return {
      page: "",
      showCleanerPicker: false,
      showNav: false,
      expanded: "cc",
      showAddRoom: false
    };
  },
};
